import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { Link } from 'foundations-components/transitional/components/Link';
import { useSearchParams } from 'marketplace-ui-common/hooks/useSearchParams';
import { useTrackMarketplaceEvent } from 'marketplace-ui-tracking';
import { getMarketplaceInteractionEvent } from 'marketplace-ui-tracking/events/marketplace';
import { SliderSection } from '../../components/SliderSection';
import { useAuth } from '../../context/AuthContext';
import { useGetSuggestionSections } from '../../hooks/useGetSuggestionSections';
import { useProductTypeSearchParam } from '../../hooks/useProductTypeSearchParams';
import { isQa } from '../../utils/env';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FEEDBACK_SURVEY_URL = {
  qa: 'https://survey.hsformsqa.com/1Gts5cjB_RaW5RhIsfGulZw1nzr9v',
  prod: 'https://survey.hsforms.com/1aOqSsquRQYWUgs_20YLUMQ1h'
};
function getFeedbackSurveyUrl(email) {
  const baseUrl = isQa() ? FEEDBACK_SURVEY_URL.qa : FEEDBACK_SURVEY_URL.prod;
  return email ? `${baseUrl}?email=${encodeURIComponent(email)}` : baseUrl;
}
export function NoResults() {
  var _auth$user, _data$result;
  const params = useSearchParams();
  const search = params.get('search');
  const productType = useProductTypeSearchParam();
  const trackMarketplaceEvent = useTrackMarketplaceEvent();
  const auth = useAuth();
  const userEmail = (_auth$user = auth.user) === null || _auth$user === void 0 ? void 0 : _auth$user.email;
  trackMarketplaceEvent(getMarketplaceInteractionEvent({
    action: 'search dead end reached',
    search
  }));
  const handleFeedbackLinkClick = () => {
    trackMarketplaceEvent(getMarketplaceInteractionEvent({
      action: 'feedback survey link clicked'
    }));
  };
  const {
    data
  } = useGetSuggestionSections(Object.assign({
    maximumSections: 1,
    minimumSectionCardCount: 3
  }, productType ? {
    productTypes: [productType]
  } : {}));
  const sections = data === null || data === void 0 || (_data$result = data.result) === null || _data$result === void 0 ? void 0 : _data$result.sections;
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    alignItems: "start",
    gap: "1000",
    marginBlockStart: "800",
    marginInlineEnd: "400",
    children: [/*#__PURE__*/_jsxs(View, {
      children: [/*#__PURE__*/_jsx(Text, {
        typography: "heading-600",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplaceStorefront.searchResults.noResults.title"
        })
      }), /*#__PURE__*/_jsx(Text, {
        typography: "body-100",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplaceStorefront.searchResults.noResults.description"
        })
      }), /*#__PURE__*/_jsxs(Text, {
        typography: "body-100",
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplaceStorefront.searchResults.noResults.feedbackText"
        }), ' ', /*#__PURE__*/_jsx(Link, {
          href: getFeedbackSurveyUrl(userEmail),
          external: true,
          onClick: handleFeedbackLinkClick,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketplaceStorefront.searchResults.noResults.feedbackLinkText"
          })
        }), "."]
      })]
    }), sections === null || sections === void 0 ? void 0 : sections.map((section, index) => {
      var _section$cards, _section$contexts;
      return /*#__PURE__*/_jsx(SliderSection, {
        cards: (_section$cards = section.cards) !== null && _section$cards !== void 0 ? _section$cards : [],
        context: (_section$contexts = section.contexts) === null || _section$contexts === void 0 ? void 0 : _section$contexts[0],
        sectionIndex: index,
        sectionType: section.sectionType,
        title: section.title
      }, index);
    })]
  });
}